module.exports = __webpack_public_path__ + "img/midbottom.a31ec11c.png";